import { useRef } from 'react';
import { useButton } from '@react-aria/button';
import I18n from 'I18n';
import styled from 'styled-components';
import VizExImage from 'visitor-ui-component-library/image/VizExImage';
import GifBadge from './GifBadge';
import MediaCaption from './MediaCaption';
import BaseMediaWrapper from './MediaWrapper';
import BaseThumbnailButton from './ThumbnailButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MediaWrapper = styled(BaseMediaWrapper).withConfig({
  displayName: "GifCard__MediaWrapper"
})(["display:inline-block;"]);
const ThumbnailButton = styled(BaseThumbnailButton).withConfig({
  displayName: "GifCard__ThumbnailButton"
})(["position:relative;"]);
const GifCard = ({
  fileMetadata,
  onPress
}) => {
  const {
    url,
    displayName: name
  } = fileMetadata;
  const buttonRef = useRef(null);
  const {
    buttonProps
  } = useButton({
    onPress
  }, buttonRef);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(MediaWrapper, {
      children: /*#__PURE__*/_jsxs(ThumbnailButton, Object.assign({}, buttonProps, {
        ref: buttonRef,
        "aria-label": I18n.text('conversations-visitor-ui.spotlight.lightbox.viewImage', {
          name
        }),
        children: [/*#__PURE__*/_jsx(VizExImage, {
          src: url,
          alt: name,
          style: {
            width: '100%'
          }
        }), /*#__PURE__*/_jsx(GifBadge, {
          children: I18n.text('conversations-visitor-ui.spotlight.mediaCard.gifBadge')
        })]
      }))
    }), /*#__PURE__*/_jsx(MediaCaption, {
      children: name
    })]
  });
};
GifCard.displayName = 'GifCard';
export default GifCard;